<template>
    <div class="box">
        <div class="top">
            <div class="top_left">
                <div class="top-a"></div>
                <p class="top-b">人员效率分析</p>
            </div>
            <div class="top_right">
                <Button class="middle-cb" @click="toinfo">
                    详情
                    <Icon type="ios-arrow-forward" />
                </Button>
            </div>
        </div>
        <div class="bottom">
            <Table :columns="columns" :row-class-name="rowClassName" :data="data" height="270"></Table>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    data() {
        return {
            button: "本月",
            columns: [
                {
                    title: "姓名",
                    key: "nickName",
                    align: "center"
                },
                {
                    title: "待接单",
                    key: "pendingOrder",
                    align: "center"
                    // tooltip: "true",
                },
                {
                    title: "处理中",
                    key: "beingProcessed",
                    align: "center"
                },
                {
                    title: "已完成",
                    key: "completed",
                    align: "center"
                },
                {
                    title: "完成率",
                    key: "finishingRate",
                    align: "center",
                    render: (h, params) => {
                        let finishingRate = params.row.finishingRate
                        return (<div>{finishingRate}%</div>)
                    }
                },
                {
                    title: "平均响应",
                    key: "averabgeResponseTime",
                    align: "center"
                },
                {
                    title: "平均时长",
                    key: "averageTime",
                    align: "center"
                },
                {
                    title: "满意度",
                    key: "satisfaction",
                    align: "center"
                },
                {
                    title: "本月积分",
                    key: "pointsMonth",
                    align: "center"
                },
            ],
            data: [],
            startDate: "",
            endDate: "",
        };
    },
    created() {
        this.loadHomeData()
    },
    methods: {
        toinfo() {
            $utils.url.push({
                name: "eightinfo_index",
            });
        },
        rowClassName(row, index) {
            return "demo-three demo";
        },
        loadHomeData() {
            let q = {
            };
            $utils.api.load("/admin/statistics/maintainerStatistics", q, "GET").then((res) => {
                if (res.data) {
                    let info = res.data || {};
                    this.data = info.slice(0, 6)
                }
            });
        },
    },
};
</script>
  
<style lang="less" scoped>
.box {
    width: 100%;
    height: 330px;
    padding: 10px;
    overflow: hidden;
}

.top {
    display: flex;
    margin-bottom: 10px;
    // justify-content: space-between;
    align-items: center;

    .top_left {
        display: flex;
        height: 20px;
        margin-right: 20px;
    }

    .top-a {
        width: 10px;
        height: 100%;
        background-color: #46a6ff;
    }

    .top-b {
        margin-left: 7px;
        font-weight: 600;
        color: black;
    }
}

.middle {
    width: 100%;
    display: flex;
    margin-bottom: 10px;

    .middle-a {
        margin-right: 8px;
    }

    .middle-b {
        margin-right: 8px;
    }

    .middle-c {
        .middle-ca {
            margin-right: 8px;
        }
    }
}

.bottom {
    height: 270px;
}

/deep/.ivu-table .demo td {
    height: 35px;
}

/deep/.ivu-table .demo-one td {
    font-weight: 600;
    color: red;
}

/deep/.ivu-table .demo-two td {
    font-weight: 600;
    color: #ffc621;
}

/deep/.ivu-table .demo-three td {
    font-weight: 600;
    color: #0000ff;
}

/deep/.ivu-table .demo-four td {
    font-weight: 600;
}

.ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled) {
    background: #46a6ff;
    color: #fff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked {
    border-color: #46a6ff;
    box-shadow: -1px 0 0 0 #46a6ff;
    z-index: 1;
}

.ivu-radio-group-button .ivu-radio-wrapper:hover {
    position: relative;
    color: #46a6ff;
}

.ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled):hover {
    background: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:hover {
    border-color: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus {
    box-shadow: none;
    transition: none;
}

.iwu-btn-primary:focus {
    box-shadow: none;
}

.ivu-btn:focus {
    box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:before {
    background: none;
    opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
    background: none;
    transition: none;
}

.ivu-radio-group-button .ivu-radio-wrapper:after {
    background: none;
    opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
    background: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child {
    border-color: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child {
    box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:after {
    opacity: 0;
}
</style>
  